import * as React from 'react';
import { createStyles, makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import { IIdNamePair } from '../../services/ResourceRelationsService';
import { Autocomplete } from '@material-ui/lab';

interface OptionType {
	label: string,
	value: string,
};

export type ILevelPermission = OptionType & IIdNamePair;

const useStyles = makeStyles((theme) =>
	createStyles({
	}),
);

interface IComboboxMIProps {
	value: ILevelPermission[],
	onChange: (value: ILevelPermission[]) => void,

	loadData: (text: string, callback: (data: ILevelPermission[]) => void) => void,
}


interface IProps {
	value: ILevelPermission[]
	options: ILevelPermission[],
	onChange: (values: ILevelPermission[]) => void,
}

export default function AuthorizationLevelControl(props: IProps)
{
	const classes = useStyles({});

	return (<Autocomplete
		multiple
		className="mi-lab-autocomplete"
		value={props.value}
		onChange={(event, newValue) => {
			let nv = newValue as ILevelPermission[];
			props.onChange(nv);
		}}
		getOptionLabel={(option: ILevelPermission) => option.label}
		options={props.options}

		renderInput={params => (
			<TextField
				{...params}
				variant="outlined"
				fullWidth
				InputProps={{
					...params.InputProps,
					autoComplete: 'disabled',

					endAdornment: (
						<React.Fragment>
							{params.InputProps.endAdornment}
						</React.Fragment>
					),
				}}
			/>
		)}

		renderOption={(option: ILevelPermission) => {
			return (
				<div className="role-permission-option">
					{option.label}
				</div>
			);
		}}
	/>);

}